export const CREATE_DATE = 'CreateDate';
export const MODIFY_DATE = 'ModifyDate';
export const DATE = 'MetadataDate';
export const DATETIME_ORIGINAL = 'DateTimeOriginal';
export const CREATOR = 'Creator';
export const PRODUCER = 'Producer';
export const AUTHOR = 'Author';
export const TITLE = 'Title';
export const SOFTWARE = 'Software';
export const WRITER_NAME = 'WriterName';
export const CREATOR_TOOL = 'CreatorTool';
export const XMP_TOOL_KIT = 'XMPToolkit';
export const HISTORY_WHEN = 'HistoryWhen';
export const HISTORY_ACTION = 'HistoryAction';
export const HISTORY_SOFTWARE_AGENT = 'HistorySoftwareAgent';
export const HISTORY = 'History';
export const READER_NAME = 'ReaderName';
export const PDF_VERSION = 'PDFVersion';
export const TEXT_LAYER_TEXT = 'TextLayerText';
export const ANOMALY = 'Anomaly';
